<template>
  <svg width="24" height="12" viewBox="0 0 24 12">
    <path
      fill="var(--geist-background)"
      stroke-width="1px"
      stroke="var(--accents-2)"
      fill-rule="evenodd"
      d="M20 12l-8-8-12 12"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'zi-popover-icon',
}
</script>
